import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import {
  withCampaignSiteMap,
  siteMapPropType,
  processorSet,
} from '@bingads-webui-campaign-react/with-site-map';
import { withScope } from '@bingads-webui-react/scope-service';
import { withLayoutContext, Mode } from '@bingads-webui-react/app-layout-container';
import { SummaryBar } from '@bingads-webui-campaign-react/summary-bar';

const isInCampaignAdGroupCreationPage = () => (
  window.location.href.indexOf('createcampaign') > -1 ||
  window.location.href.indexOf('createadgroup') > -1 ||
  window.location.href.indexOf('conversiongoals/create') > -1 ||
  window.location.href.indexOf('conversiongoals/autocreate') > -1 ||
  window.location.href.indexOf('conversiongoals/edit') > -1 ||
  window.location.href.indexOf('conversionvaluerules/create') > -1 ||
  window.location.href.indexOf('conversionvaluerules/edit') > -1 ||
  window.location.href.indexOf('uettags/create') > -1 ||
  window.location.href.indexOf('uettags/edit') > -1 ||
  window.location.href.indexOf('audience/create') > -1 ||
  window.location.href.indexOf('audience/edit') > -1 ||
  window.location.href.indexOf('createassociation') > -1 ||
  window.location.href.indexOf('recommendations/history') > -1 ||
  window.location.href.indexOf('recommendations/AutoApplySettings') > -1 ||
  window.location.href.indexOf('reports-v4') > -1
);

export const Loader = (props) => {
  const {
    siteMap, updateAvailability, changeLayout, scope, layoutConfig, ...others
  } = props;

  const FullScreenWithTabConfig = {
    header: {
      mode: Mode.Hidden,
    },
    nav: {
      mode: Mode.Hidden,
    },
    status: {
      mode: Mode.Hidden,
    },
    menu: {
      mode: Mode.Hidden,
    },
    subTab: {
      mode: Mode.Hidden,
    },
  };

  const selectedParent = _.findWhere(siteMap, { selected: true });

  const getConfigComponents = config => ({
    ..._.pick(config, 'header', 'nav', 'status', 'menu', 'subTab'),
    menu: {
      mode: config.menu && config.menu.mode,
    },
  });

  const isTableExpanded = useMemo(
    () => (
      _.isEqual(
        getConfigComponents(layoutConfig),
        FullScreenWithTabConfig
      )),
    [FullScreenWithTabConfig, layoutConfig]
  );
  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });

  if (selectedParent && scope && !scope.values.campaignId) {
    changeLayout({ status: { mode: Mode.Hidden } });
    return null;
  }
  if (!isTableExpanded &&
    layoutConfig && layoutConfig.status.mode !== Mode.Expanded &&
    !isInCampaignAdGroupCreationPage(siteMap)) {
    changeLayout({ status: { mode: Mode.Expanded } });
  }

  return selectedParent ? (<SummaryBar {...others} canEdit />) : null;
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  scope: PropTypes.shape({
    values: PropTypes.object.isRequired,
  }).isRequired,
  changeLayout: PropTypes.func.isRequired,
  layoutConfig: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }).isRequired,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
};

export const CampaignSummaryBarLoader = withLayoutContext(withScope((withCampaignSiteMap(
  React.memo(Loader),
  processorSet.all
))));
